import React, { useRef, useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import Popover from '../Popover';
import classnames from 'classnames';
import styles from './NotificationBadge.module.css';
import Notifications from './Notifications';
import DrawerComponent from '../DrawerComponent';
import useNotifications from './notification.hook';
const { Badge } = MaterialUiCore;
const DEFAULT_POPOVER_PROPS = {
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'right',
    },
    chevronHeight: 8,
    popoverStyles: {
        popover: ({ anchorEl, chevronHeight }) => {
            if (!anchorEl) {
                return {};
            }

            const { height: anchorHeight, width: anchorWidth } = anchorEl.getBoundingClientRect();
            return {
                transform: `translate(${
                    2 * chevronHeight - Math.floor(anchorWidth / 2)
                }px) translateY(${chevronHeight}px) !important`,
            };
        },
        popover__chevron: ({ chevronHeight }) => {
            return {
                'border-left': `${chevronHeight}px solid transparent`,
                'border-right': `${chevronHeight}px solid transparent`,
                'border-bottom': `${chevronHeight}px solid #FFF`,
                right: `${chevronHeight}px`,
                top: `calc(-1 * ${chevronHeight}px)`,
            };
        },
    },
};
export default function NotificationBadge({ modsWithNotifications, notificationPreferences, ...otherProps }) {
    const { notifications, count, markNotificationsAsSeen, maxNotificationsInPopover, maxNotificationsInDrawer } =
        useNotifications(modsWithNotifications, notificationPreferences);
    const badgeRef = useRef();
    const [popoverOpen, setPopoverOpen] = useState(otherProps.popoverOpen);
    const [drawerOpen, setDrawerOpen] = useState(otherProps.drawerOpen);

    const onDrawerClose = () => setDrawerOpen(false);

    const onPopOverClose = () => {
        setPopoverOpen(false);

        if (!notifications.length) {
            return;
        }

        markNotificationsAsSeen(notifications);
    };

    const onViewAll = () => {
        setPopoverOpen(false);
        setDrawerOpen(true);
        markNotificationsAsSeen(notifications);
    };

    const onBadgeClick = () => {
        setPopoverOpen(true);
        modsWithNotifications.forEach((mod) => mod.onBadgeClick());
    };

    return (
        <>
            <Badge
                badgeContent={count}
                ref={badgeRef}
                onClick={onBadgeClick}
                classes={{
                    root: styles['notification-badge'],
                    badge: styles['notification-badge__badge'],
                }}
            >
                <span className={classnames('sct-icon', 'icon-Nottification-18', styles['notification-badge__icon'])} />
            </Badge>
            {popoverOpen && (
                <Popover
                    open={popoverOpen}
                    anchorEl={badgeRef.current}
                    onClose={onPopOverClose}
                    {...DEFAULT_POPOVER_PROPS}
                >
                    <Notifications
                        list={notifications.slice(0, maxNotificationsInPopover)}
                        onViewAll={onViewAll}
                        styleConfig={{
                            hasPadding: true,
                        }}
                    />
                </Popover>
            )}
            {drawerOpen && (
                <DrawerComponent open={drawerOpen} handleClose={onDrawerClose} position="right">
                    <Notifications list={notifications.slice(0, maxNotificationsInDrawer)} onClose={onDrawerClose} />
                </DrawerComponent>
            )}
        </>
    );
}
